import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-testimonials',
    carousel: '.splide',
    arrows: '.splide__arrows',
    prev: '.splide__arrow--prev',
    next: '.splide__arrow--next',
};

const DEFAULT_OPTIONS = {
    type: 'fade',
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: false,
    rewind: true,
};

export function initTestimonials(block) {
    if (!block) return;

    const carousel = block.querySelector(SELECTORS.carousel);

    if (!carousel) return;

    // Skip if already initialized
    if (carousel.splide) {
        return null;
    }

    try {
        const splide = new Splide(carousel, DEFAULT_OPTIONS);

        if (!splide) return;

        const eventCleanup = [];

        splide.on('mounted', function () {
            try {
                const prevButtons = carousel.querySelectorAll(SELECTORS.prev);
                const nextButtons = carousel.querySelectorAll(SELECTORS.next);
                const arrows = carousel.querySelectorAll(SELECTORS.arrows);
                const shouldShowArrows = splide.length > 1;

                if (arrows.length > 0) {
                    arrows.forEach((arrow) => {
                        arrow.style.display = shouldShowArrows ? '' : 'none';
                    });
                }

                if (prevButtons.length) {
                    prevButtons.forEach((button) => {
                        const handler = () => splide.go('<');
                        button.addEventListener('click', handler);
                        eventCleanup.push(() => button.removeEventListener('click', handler));
                    });
                }

                if (nextButtons.length) {
                    nextButtons.forEach((button) => {
                        const handler = () => splide.go('>');
                        button.addEventListener('click', handler);
                        eventCleanup.push(() => button.removeEventListener('click', handler));
                    });
                }
            } catch (error) {
                console.error('Error setting up Testimonials carousel controls:', error);
            }
        });

        splide.mount();

        return {
            destroy() {
                eventCleanup.forEach((cleanup) => cleanup());
                if (splide && typeof splide.destroy === 'function') {
                    splide.destroy();
                }
                delete carousel.splide;
            },
        };
    } catch (error) {
        console.error('Error initializing Testimonials carousel:', error, carousel);

        return null;
    }
}

export function Testimonials() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initTestimonials(block);
    });
}
